import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/wedding-guest-list-app";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-guest-list-app")({
  head: SEO["/wedding-guest-list-app"],
  component: () => <ContentPage path="/wedding-guest-list-app" body={body} />,
});
